<i nz-icon [nzType]="'ng-zorro:' + type" class="digi-icon" [style.color]="color"></i>
